import React, { useState } from "react";
import {
  Box,
  VStack,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Text,
  Divider,
} from "@chakra-ui/react";
import { FiSettings, FiUsers } from "react-icons/fi";
import BreakSettings from "./BreakSettings";
import EmployeeBreakSettingsTable from "./EmployeeBreakSettingsTable";

const BreakSettingsTab = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box>
      <Tabs index={activeTab} onChange={setActiveTab} variant="enclosed" colorScheme="blue">
        <TabList mb={6}>
          <Tab
            _selected={{ bg: "blue.500", color: "white" }}
            borderRadius="12px"
            mr={2}
          >
            <Box display="flex" alignItems="center" gap={2}>
              <FiSettings size={16} />
              <Text>Company/Branch Settings</Text>
            </Box>
          </Tab>
          <Tab
            _selected={{ bg: "blue.500", color: "white" }}
            borderRadius="12px"
          >
            <Box display="flex" alignItems="center" gap={2}>
              <FiUsers size={16} />
              <Text>Employee Overrides</Text>
            </Box>
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel p={0}>
            <BreakSettings />
          </TabPanel>
          <TabPanel p={0}>
            <Box p={6}>
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text fontSize="lg" fontWeight="600" color="gray.900" mb={2}>
                    Employee Break Settings
                  </Text>
                  <Text fontSize="sm" color="gray.600">
                    Set custom break hours for individual employees. Employees without overrides will use the company/branch default.
                  </Text>
                </Box>
                <Divider />
                <EmployeeBreakSettingsTable />
              </VStack>
            </Box>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default BreakSettingsTab;

